import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { adminCampaignsSlice, adminConfigCategoriesSlice } from 'src/modules/adminCampaigns/slices';
import { applicationsReducer } from 'src/modules/applications/slices';
import { campaignsReducer } from 'src/modules/campaigns/slices';
import { companiesReducer } from 'src/modules/companies/slices';
import { homeReducer } from 'src/modules/home/slices';
import { surveyResponsesReducer } from 'src/modules/surveyResponses/slices';
import { contactsReducer } from 'src/modules/contacts/slices';
import { groupsReducer } from 'src/modules/groups/slices';
import { keywordsReducer } from 'src/modules/keywords/slices';
import { plansReducer } from 'src/modules/plans/slices';
import { inboxReducer } from 'src/modules/inbox/slices';
import assetLibraryReducer from 'src/modules/assetLibrary/slices/assetLibrarySlice';
import { blocklistReducer } from 'src/modules/blocklist/slices';
import { shortLinkReducer } from 'src/modules/shortLinks/slices';
import { permissionsReducer, profileReducer, roleReducer } from 'src/modules/profile/slices';
import { canvaReducer } from 'src/modules/canva/slices';
import alertsReducer from 'src/modules/alerts/slices/alertsSlice';
import reportsReducer from 'src/modules/reports/slices/reportsSlice';
import { campaignConfigReducer } from 'src/modules/campaignConfigBuilder/slices';
import { automationsReducer } from 'src/modules/automations/slices';
import { campaignCreateOptionsReducer } from 'src/modules/campaignCreateOptions/slices';
import { contactCaptureReducer } from 'src/modules/contactCapture/slices';

const appReducer = combineReducers({
  adminCampaigns: adminCampaignsSlice,
  adminConfigCategories: adminConfigCategoriesSlice,
  applications: applicationsReducer,
  plans: plansReducer,
  keywords: keywordsReducer,
  shortLink: shortLinkReducer,
  blocklist: blocklistReducer,
  campaigns: campaignsReducer,
  surveyResponses: surveyResponsesReducer,
  groups: groupsReducer,
  contacts: contactsReducer,
  companies: companiesReducer,
  home: homeReducer,
  alerts: alertsReducer,
  assetLibrary: assetLibraryReducer,
  permissions: permissionsReducer,
  profile: profileReducer,
  roles: roleReducer,
  inbox: inboxReducer,
  canva: canvaReducer,
  reports: reportsReducer,
  campaignConfig: campaignConfigReducer,
  automations: automationsReducer,
  campaignCreateOptions: campaignCreateOptionsReducer,
  contactCapture: contactCaptureReducer,
});

type RootState = ReturnType<typeof appReducer>;

type RootAction = Action<"logout">;

const rootReducer = (state: RootState | undefined, action: RootAction): RootState => {
  if (action.type === "logout") {
    return appReducer(undefined, { type: "init" });
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export type { RootState };
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
